import { render, staticRenderFns } from "./driverInviteDetails.vue?vue&type=template&id=8c235568&scoped=true&"
import script from "./driverInviteDetails.vue?vue&type=script&lang=js&"
export * from "./driverInviteDetails.vue?vue&type=script&lang=js&"
import style0 from "./driverInviteDetails.vue?vue&type=style&index=0&id=8c235568&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c235568",
  null
  
)

export default component.exports